import { InjectionToken } from "@angular/core";

export const WEBAPI_PREFIX_TOKEN = new InjectionToken<string>('web api prefix string.');

export function appendPerfixForUri(uri: string, perfix: string = '') {
    if (perfix) {
        perfix = perfix.replace(/\/\//g, '/').replace(/\\/g, '/');
        if (perfix[perfix.length - 1] == '/' && uri[0] == '/') {
            return perfix + uri.substring(1);
        }

        return perfix + uri;
    }

    return uri;
}